import { createORPCClient } from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import { getGlobalClient, setGlobalClient, type GlobalAppClient } from "./index";

const link = new RPCLink({
  fetch: (input, init) => fetch(input, { ...init, credentials: "include" }),
  url: () => {
    if (typeof window === "undefined") {
      throw new Error("RPCLink is not allowed on the server side.");
    }

    return new URL("/rpc", window.location.href);
  },
});

export const apiClient: GlobalAppClient = getGlobalClient() ?? createORPCClient(link);

if (!getGlobalClient()) {
  setGlobalClient(apiClient);
}

export const orpc = createTanstackQueryUtils(apiClient);
